import { Map, Record } from "immutable";

import {
  CrudBuilderState,
  makeCrudBuilderInitialState
} from "seneca-common/utils/apiStates/crudBuilder/models/CrudBuilderState";

import {
  childClassEnrollmentsCrudConfig,
  classEnrollmentsCrudConfig
} from "../consts";

export type ClassEnrollmentsMetaState = CrudBuilderState;

export const defaultStudentClassEnrollmentsMetaState =
  makeCrudBuilderInitialState(classEnrollmentsCrudConfig);

export const defaultChildClassEnrollmentsMetaState =
  makeCrudBuilderInitialState(childClassEnrollmentsCrudConfig);

export type ClassEnrollmentsMetaType = {
  studentClassEnrollments: ClassEnrollmentsMetaState | Map<any, any>;
  childClassEnrollments: ClassEnrollmentsMetaState | Map<any, any>;
};

const defaultClassEnrollmentsMeta: ClassEnrollmentsMetaType = {
  studentClassEnrollments: defaultStudentClassEnrollmentsMetaState,
  childClassEnrollments: defaultChildClassEnrollmentsMetaState
};

export default class ClassEnrollmentsMeta extends Record(
  defaultClassEnrollmentsMeta
) {}
